export const DATA_HOOKS = {
    VALUE: 'counter-badge-value',
};
//# sourceMappingURL=constants.js.map